import _ from 'lodash';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import NumberFormat from 'react-number-format';
import OneClickButton from '../form/button';
import addNotification from '../notification';
import Table from '../table/Table';
import Form from '../form/form';
import { getUserPrinterOptions } from '../../app/store/actions/printers';
import {
  getVolumes,
} from '../../app/store/actions/outboundOrderVolumes';
import ModalTypePackaging from '../../pages/outbound/check/modalTypePackaging';
import {
  confirmPick,
  getOutboundRangePicking,
} from '../../app/store/actions/outboundOrdersPicking';

class PrintVolumeAssemblyLabel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultPageSize: 3,
      pageSizeOptions: [3, 5, 10],
      labelsToPrint: [],
      labelsToPrintTotalQuantity: 0,
      printerOptions: [],
      showPrinterDialog: false,
      printerSelected: null,
      volumeWeight: 0,
      totalClosedVolumes: 0,
      packageCode: '',
      openModalPackaging: false,
      isFinishing: false,
      showConfirmPickingDialog: false,
      filteredLabels: [],
      title: I18n.t('BEE4355' /* Monitor de Cross-Docking */),
    };

    this.tableColumns = this.getTableColumns();
  }

  async componentDidMount() {
    this.setInitState();
    this.setFormInitState();
    this.getFormData();
    this.getUserPrinterOptions();
  }

  componentDidUpdate(prevProps) {
    const { orderNumber } = this.props;
    if (this.props.outboundVolumeList && this.props.outboundVolumeList.success !== false
      && prevProps.outboundVolumeList !== this.props.outboundVolumeList
      && prevProps.outboundVolumeList.length !== this.props.outboundVolumeList.length
    ) {
      this.setClosedVolumes(orderNumber);
    }
  }

  async componentWillUnmount() {
    this.setFormInitState();
  }

  setInitState = () => {
    this.setState({
      volumeWeight: 0,
      totalClosedVolumes: 0,
    });
  };

  setFormInitState = () => {
    this.setState({
      packageCode: '',
      printerSelected: null,
      showPrinterDialog: false,
      openModalPackaging: false,
      isFinishing: false,
    });
  };

  setValue = (field, value) => {
    this.setState({ [field]: value });
  };

  getTableColumns = () => {
    const columns = [{
      Header: I18n.t('BEE225' /* Produto */),
      accessor: 'productCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 80,
    },
    {
      Header: I18n.t('BEE277' /* Descrição */),
      accessor: 'productName',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
    },
    {
      Header: I18n.t('BEE4391' /* Quantidade Disponível */),
      accessor: 'availableQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
    }, {
      Header: I18n.t('BEE4390' /* Quantidade no Volume */),
      accessor: 'volumeQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Cell: (row) => (
        <div style={{ textAlign: 'center' }}>
          <NumberFormat
            className="form-control"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={!this.props.fractionalQuantity ? 0 : 4}
            value={row.value}
            onBlur={(values) => {
              const rawValue = values.target.value;
              let updatedValue = parseFloat(rawValue.replace(',', '.'));
              if (row.value !== updatedValue) {
                updatedValue = updatedValue || 0;
                this.setState((prevState) => {
                  const { labelsToPrint } = prevState;

                  const currentLabel = labelsToPrint.find((label) => label.id === row.original.id);
                  if (currentLabel) {
                    const updatedLabelsToPrint = labelsToPrint.map((label) => (label.id === row.original.id
                      ? { ...label, volumeQuantity: updatedValue }
                      : label));

                    this.setLabelsToPrint(updatedLabelsToPrint);
                    return;
                  }
                  return null;
                });
              }
            }}
            allowNegative={false}
            fixedDecimalScale
            disabled={false}
          />
        </div>
      ),
    }];

    return columns;
  };

  closeModalPrintVolumeAssemblyLabel = () => {
    this.setLabelsToPrint([]);
    this.props.closeModalPrintVolumeAssemblyLabel();
  };

  openModalPackaging = () => {
    this.setState({
      openModalPackaging: true,
    });
  };

  selectPackaging = async (selectPackaging) => {
    const { packageCode } = this.state;
    if (packageCode !== selectPackaging.code) {
      await this.setState({
        packageCode: selectPackaging.code,
        openModalPackaging: false,
      });
      this.volumeAssembly();
    } else {
      this.setState({ openModalPackaging: false });
      this.volumeAssembly();
    }
  };

  setLabelsToPrint = async (labelsToPrint) => {
    const { orderNumber } = this.props;
    this.setState({
      labelsToPrint,
      labelsToPrintTotalQuantity: labelsToPrint.reduce((acc, label) => acc + (label.volumeQuantity || 0), 0),
    }, () => {
      this.setVolumeWeight(labelsToPrint);
      this.setClosedVolumes(orderNumber);
    });
  };

  volumeAssembly = async () => {
    const { labelsToPrint, printerSelected } = this.state;
    const filteredLabels = labelsToPrint.filter((label) => label.volumeQuantity > 0);
    if (filteredLabels.length === 0) {
      addNotification(
        'danger',
        I18n.t('BEE4389' /* Montagem do Volume */),
        I18n.t('BEE4399' /* É necessário informar pelo menos um produto com quantidade maior que zero */),
        'top-right',
      );
      return;
    }

    if (printerSelected === null) {
      await this.checkPrinters();
      return;
    }

    this.setState({
      showConfirmPickingDialog: true,
      filteredLabels,
    });
  };

  confirmPickingSubmit = async (filteredLabelsToPrint) => {
    try {
      const { volumeWeight } = this.state;

      this.setState({ showConfirmPickingDialog: false, filteredLabels: [] });

      const results = await Promise.all(
        filteredLabelsToPrint.map((element) => this.props.confirmPick(
          element.outboundRangeProductId,
          element.volumeQuantity,
          null,
          element.storageAddressCode,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          true,
          volumeWeight,
        )),
      );

      let hasError = false;
      results.forEach((result) => {
        if ((result && result.success === false) || !result) {
          addNotification(
            'danger',
            this.state.title,
            I18n.t('BEE4400' /* Erro na geração do volume Cross-Docking */),
            'top-right',
          );
          hasError = true;
        } else {
          this.props.getCrossdockingList();

          addNotification(
            'success',
            this.state.title,
            I18n.t('BEE2037' /* Volume consolidado com sucesso! */),
            'top-right',
          );
        }
      });

      if (!hasError) {
        this.getFormData();
      }
    } catch (error) {
      const messageError = error.response && error.response.data
        && error.response.data.error && error.response.data.error.message;
      if (messageError) {
        addNotification(
          'danger',
          this.state.title,
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          this.state.title,
          I18n.t('BEE4400' /* Erro na geração do volume Cross-Docking */),
          'top-right',
        );
      }
    }
  };

  getUserPrinterOptions = async () => {
    const Info = await this.props.getUserPrinterOptions();
    const { userPrinter, printerOptions } = Info;
    const { printerSelected } = this.state;

    this.setState({
      printerOptions,
      printerSelected: (printerSelected === null
        ? userPrinter
        : printerSelected !== userPrinter
            && printerSelected)
             || userPrinter,
    });
  };

  hidePrinterDialog = () => {
    this.setState({
      showPrinterDialog: false,
      printerSelected: null,
    });
  };

  checkPrinters = async () => {
    const {
      printerOptions,
      printerSelected,
    } = this.state;

    if (printerOptions.length === 0 && printerSelected === null) {
      addNotification(
        'danger',
        I18n.t('BEE4196' /* Impressão de Etiquetas */),
        I18n.t('BEE1415' /* Usuário não possui impressora relacionada */),
        'top-right',
      );
    } else if (printerOptions && printerOptions.length > 0 && printerSelected === null) {
      this.setState({
        showPrinterDialog: true,
      });
    } else {
      await this.volumeAssembly();
    }
  };

  setVolumeWeight = (labelsToPrint) => {
    const volumeWeight = labelsToPrint.reduce((acc, label) => {
      const weight = label.volumeQuantity * label.grossWeight;
      return acc + weight;
    }, 0);

    this.setState({
      volumeWeight,
    });
  };

  setClosedVolumes = async (orderNumber) => {
    const { outboundVolumeList } = this.props;
    await this.props.getVolumes(orderNumber);
    if (outboundVolumeList && outboundVolumeList.length > 0) {
      this.setState({ totalClosedVolumes: outboundVolumeList.length });
    }
  };

  getFormData = async () => {
    try {
      const { outboundRangeId, outboundRangeProductId } = this.props;
      const products = await this.props.getOutboundRangePicking(outboundRangeId, true);

      if (products && products.length > 0) {
        const productRows = products
          .map((product, index) => ({
            id: index,
            productCode: product.productCode,
            productName: product.productFullName,
            volumeQuantity: 0,
            grossWeight: product.grossWeight,
            customerProductCode: product.customerProductCode,
            storageAddressCode: product.addressCode,
            outboundRangeProductId: product.outboundRangeProductId,
            availableQuantity: product.quantity,
          })).filter((product) => product.availableQuantity > 0);
        const productsRange = productRows.filter((p) => p.outboundRangeProductId === outboundRangeProductId);
        if (productsRange.length > 0) {
          await this.setLabelsToPrint(productsRange);
        } else {
          this.props.closeModalPrintVolumeAssemblyLabel();
        }
      }
    } catch (error) {
      const messageError = error.response && error.response.data
        && error.response.data.error && error.response.data.error.message;
      if (messageError) {
        addNotification(
          'danger',
          this.state.title,
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          this.state.title,
          I18n.t('BEE4400' /* Erro na geração do volume Cross-Docking */),
          'top-right',
        );
      }
      this.props.closeModalPrintVolumeAssemblyLabel();
    }
  };

  renderForm = () => {
    const {
      labelsToPrint, defaultPageSize, pageSizeOptions, volumeWeight, totalClosedVolumes, labelsToPrintTotalQuantity,
    } = this.state;

    return (
      <form onSubmit={(e) => e.preventDefault()} noValidate>
        <div style={{ marginLeft: -15, marginRight: -15 }}>
          <Table
            panelHeaderProps={{
              noButton: true,
              children: I18n.t('BEE4389' /* Montagem do Volume */).toUpperCase(),
            }}
            filterable
            data={labelsToPrint}
            columns={this.tableColumns}
            expander
            pageSizeOptions={pageSizeOptions}
            defaultPageSize={defaultPageSize}
            defaultFilterMethod={(filter, row) => {
              const input = _.lowerCase(filter.value);
              const value = _.lowerCase(row[filter.id]);
              if (_.includes(value, input)) {
                return true;
              }
            }}
          />
        </div>
        <hr />
        <div>
          <div className="d-inline-flex" style={{ gap: '0.8rem', flexBasis: '100%' }}>
            <div className="flex-column" style={{ flexBasis: '50%' }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createNumberFormat(
                    volumeWeight,
                    'volumeWeight',
                    `${I18n.t('BEE4392' /* Peso do Volume */)}:`,
                    !this.props.fractionalQuantity ? 0 : 4,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    ['row', 'col-form-label f-w-600', 'p-2'],
                    true,
                    undefined,
                    false,
                  ),
                ])}
              />
            </div>
            <div className="flex-column" style={{ flexBasis: '50%' }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createNumberFormat(
                    totalClosedVolumes,
                    'totalClosedVolumes',
                    `${I18n.t('BEE4393' /* Volumes Fechados */)}:`,
                    0,
                    true,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    ['row', 'col-form-label f-w-600', 'p-2'],
                    true,
                    undefined,
                    false,
                  ),
                ])}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="row align-items-center">
          <div className="ml-auto">
            <OneClickButton
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={() => this.openModalPackaging()}
              disabled={labelsToPrint.length === 0 || labelsToPrintTotalQuantity === 0 || parseFloat(volumeWeight) <= 0}
            >
              {I18n.t('BEE1956' /* Confirmar Volume */)}
            </OneClickButton>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const {
      printerOptions, showPrinterDialog, printerSelected, openModalPackaging, isFinishing,
      showConfirmPickingDialog, filteredLabels,
    } = this.state;
    const {
      openChangeModal = false, orderNumber,
    } = this.props;

    return (
      <div>
        <Modal
          size="lg"
          isOpen={openChangeModal}
          toggle={() => this.closeModalPrintVolumeAssemblyLabel()}
        >
          <ModalHeader
            toggle={() => this.closeModalPrintVolumeAssemblyLabel()}
          >
            {(`${I18n.t('BEE443' /* Documento */).toUpperCase()}: ${orderNumber}`)}
          </ModalHeader>
          <ModalBody>
            {this.renderForm()}
          </ModalBody>
        </Modal>
        {(showPrinterDialog && (
          <SweetAlert
            confirmBtnText={I18n.t('BEE436' /* Selecionar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE1324' /* Selecionar Impressora */)}
            onConfirm={() => this.volumeAssembly()}
            onCancel={() => this.hidePrinterDialog()}
          >
            <div className="mt-4">
              <Form
                noPanel
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createSelect(
                    printerSelected,
                    'printerSelected',
                    I18n.t('BEE328' /* Impressora */),
                    printerOptions,
                    '',
                    '',
                    12,
                    true,
                  ),
                ])}
              />
            </div>
          </SweetAlert>
        ))}
        {(showConfirmPickingDialog && (
          <SweetAlert
            info
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE1849' /* continuar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE4395' /* Confirmar Separação */)}
            onConfirm={() => this.confirmPickingSubmit(filteredLabels)}
            onCancel={() => this.setState({ showConfirmPickingDialog: false, filteredLabels: [] })}
          >
            {I18n.t('BEE4566' /* A separação será finalizada. Deseja continuar? */)}
          </SweetAlert>
        ))}
        <ModalTypePackaging
          isFinishing={isFinishing}
          openModalPackaging={openModalPackaging}
          closeModalPackaging={() => this.setState({
            openModalPackaging: false,
            isFinishing: false,
          })}
          checkDataShowFinishScreen={() => this.setState({ isFinishing: false })}
          selectPackaging={(selectPackaging) => this.selectPackaging(selectPackaging)}
          packageCode={this.state.packageCode}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fractionalQuantity: state.app.permissionsCompany && state.app.permissionsCompany.fractionalQuantity,
  outboundVolumeList: state.outboundOrderVolumes && state.outboundOrderVolumes.outboundVolumeList,
});

const mapDispatchToProps = (dispatch) => ({
  getUserPrinterOptions: () => dispatch(getUserPrinterOptions()),
  getVolumes: (orderNumber) => dispatch(getVolumes(orderNumber)),
  confirmPick: (
    outboundRangeProductId,
    pickedQuantity,
    baptismLabel,
    storageAddressPicked,
    serialGroupId,
    serialLabelId,
    serialLabelControl,
    confirmDivergence,
    stage,
    isCrossdocking,
    volumeWeight,
  ) => dispatch(confirmPick(
    outboundRangeProductId,
    pickedQuantity,
    baptismLabel,
    storageAddressPicked,
    serialGroupId,
    serialLabelId,
    serialLabelControl,
    confirmDivergence,
    stage,
    isCrossdocking,
    volumeWeight,
  )),
  getOutboundRangePicking: (outboundRangeId, isCrossdocking) => dispatch(getOutboundRangePicking(
    outboundRangeId,
    isCrossdocking,
  )),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PrintVolumeAssemblyLabel));
